/* =====================================================================
   VAIRO ANIMATIONS  ·  GSAP + ScrollTrigger + Lenis + Splitting
   Estética editorial Apple/Nike/Sotheby's
   ===================================================================== */
(function () {
  'use strict';

  // Marca el HTML para que el CSS aplique los estados iniciales (evita FOUC)
  document.documentElement.classList.add('vairo-anim-ready');

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    if (typeof gsap === 'undefined') {
      console.warn('[vairo-anim] GSAP no cargó');
      return;
    }
    gsap.registerPlugin(ScrollTrigger);

    /* ---------- 1. SMOOTH SCROLL (Lenis) ---------- */
    if (typeof Lenis !== 'undefined' && !reduced) {
      const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
        smoothTouch: false,
      });
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add((time) => lenis.raf(time * 1000));
      gsap.ticker.lagSmoothing(0);
      window.__vairoLenis = lenis;
    }

    /* ---------- 2. SPLITTING — texto palabra por palabra ---------- */
    if (typeof Splitting !== 'undefined') {
      const splitTargets = document.querySelectorAll('[data-vairo-split]');
      splitTargets.forEach((el) => {
        Splitting({ target: el, by: 'words' });
      });
      splitTargets.forEach((el) => {
        const words = el.querySelectorAll('.word');
        if (!words.length) return;
        gsap.to(words, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'expo.out',
          stagger: 0.04,
          scrollTrigger: { trigger: el, start: 'top 85%', once: true },
        });
      });
    }

    /* ---------- 3. FADE simple ---------- */
    gsap.utils.toArray('[data-vairo-fade]').forEach((el) => {
      gsap.to(el, {
        opacity: 1,
        duration: 1.1,
        ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 88%', once: true },
      });
    });

    /* ---------- 4. RISE (fade + translateY) ---------- */
    gsap.utils.toArray('[data-vairo-rise]').forEach((el) => {
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 1.1,
        ease: 'expo.out',
        scrollTrigger: { trigger: el, start: 'top 88%', once: true },
      });
    });

    /* ---------- 5. STAGGER de hijos ---------- */
    gsap.utils.toArray('[data-vairo-stagger]').forEach((parent) => {
      gsap.to(parent.children, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: 'expo.out',
        stagger: 0.1,
        scrollTrigger: { trigger: parent, start: 'top 85%', once: true },
      });
    });

    /* ---------- 6. PARALLAX sutil en imágenes ---------- */
    if (!reduced) {
      gsap.utils.toArray('[data-vairo-parallax]').forEach((el) => {
        const speed = parseFloat(el.dataset.vairoParallax) || 0.2;
        gsap.fromTo(
          el,
          { yPercent: -speed * 50 },
          {
            yPercent: speed * 50,
            ease: 'none',
            scrollTrigger: {
              trigger: el,
              start: 'top bottom',
              end: 'bottom top',
              scrub: true,
            },
          }
        );
      });
    }

    /* ---------- 7. IMAGE REVEAL con máscara ---------- */
    gsap.utils.toArray('[data-vairo-reveal]').forEach((el) => {
      const mask = el; // pseudo ::after se anima vía gsap to del propio elemento? usamos clip-path
      gsap.fromTo(
        el,
        { clipPath: 'inset(0 100% 0 0)' },
        {
          clipPath: 'inset(0 0% 0 0)',
          duration: 1.4,
          ease: 'expo.out',
          scrollTrigger: { trigger: el, start: 'top 85%', once: true },
          onStart: () => el.classList.add('is-revealed'),
        }
      );
    });

    /* ---------- 8. CTAs MAGNÉTICOS ---------- */
    if (!reduced && window.matchMedia('(pointer: fine)').matches) {
      document.querySelectorAll('[data-vairo-magnetic]').forEach((el) => {
        const strength = 0.35;
        el.addEventListener('mousemove', (e) => {
          const r = el.getBoundingClientRect();
          const x = (e.clientX - r.left - r.width / 2) * strength;
          const y = (e.clientY - r.top - r.height / 2) * strength;
          gsap.to(el, { x, y, duration: 0.4, ease: 'power3.out' });
        });
        el.addEventListener('mouseleave', () => {
          gsap.to(el, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.4)' });
        });
      });
    }

    /* ---------- 9. PIN secciones marcadas (opcional) ---------- */
    gsap.utils.toArray('[data-vairo-pin]').forEach((el) => {
      ScrollTrigger.create({
        trigger: el,
        start: 'top top',
        end: '+=100%',
        pin: true,
        pinSpacing: true,
      });
    });

    /* ---------- 10. AUTO-MAPEO de clases existentes Vairo ----------
       Los templates Vairo Padel Center y Distribuidores ya usan clases
       semánticas. Las animamos automáticamente sin tocar los JSON. */

    // Títulos jumbo → split palabra por palabra
    const autoSplit = document.querySelectorAll(
      '.v-display, .v-hero__title, .v-h1:not([data-vairo-skip])'
    );
    if (typeof Splitting !== 'undefined') {
      autoSplit.forEach((el) => {
        if (el.hasAttribute('data-vairo-split')) return;
        Splitting({ target: el, by: 'words' });
        const words = el.querySelectorAll('.word');
        gsap.set(words, { y: '100%', opacity: 0 });
        el.style.overflow = 'hidden';
        el.style.lineHeight = '1.05';
        gsap.to(words, {
          y: 0,
          opacity: 1,
          duration: 1.1,
          ease: 'expo.out',
          stagger: 0.05,
          scrollTrigger: { trigger: el, start: 'top 88%', once: true },
        });
      });
    }

    // Leads y eyebrows → fade-up suave
    document.querySelectorAll('.v-lead, .v-eyebrow, .v-pullquote, .v-suggest, .v-divider').forEach((el) => {
      gsap.fromTo(
        el,
        { opacity: 0, y: 24 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'expo.out',
          delay: 0.15,
          scrollTrigger: { trigger: el, start: 'top 90%', once: true },
        }
      );
    });

    // Bloques con .v-reveal → respeta data-reveal-delay
    document.querySelectorAll('.v-reveal').forEach((el) => {
      const delay = parseFloat(el.dataset.revealDelay || 0) * 0.12;
      gsap.fromTo(
        el,
        { opacity: 0, y: 36 },
        {
          opacity: 1,
          y: 0,
          duration: 1.05,
          ease: 'expo.out',
          delay,
          scrollTrigger: { trigger: el, start: 'top 88%', once: true },
        }
      );
    });

    // Grids: stagger natural en hijos
    [
      '.v-centers',
      '.v-tiles',
      '.v-features',
      '.v-stats',
      '.v-cards',
      '.v-grid',
    ].forEach((sel) => {
      document.querySelectorAll(sel).forEach((parent) => {
        const items = Array.from(parent.children);
        if (!items.length) return;
        gsap.fromTo(
          items,
          { opacity: 0, y: 40 },
          {
            opacity: 1,
            y: 0,
            duration: 0.95,
            ease: 'expo.out',
            stagger: 0.08,
            scrollTrigger: { trigger: parent, start: 'top 85%', once: true },
          }
        );
      });
    });

    // Hero: parallax sutil de imagen + fade-in del overlay/contenido
    document.querySelectorAll('.v-hero__media img, .v-hero__media picture').forEach((img) => {
      if (reduced) return;
      gsap.fromTo(
        img,
        { scale: 1.15, yPercent: -5 },
        {
          scale: 1.0,
          yPercent: 5,
          ease: 'none',
          scrollTrigger: {
            trigger: img.closest('.v-hero') || img,
            start: 'top top',
            end: 'bottom top',
            scrub: true,
          },
        }
      );
    });

    // Cards: hover lift con GSAP (más fluido que CSS transition)
    document.querySelectorAll('.v-center-card, .v-tile, .v-feature').forEach((card) => {
      if (reduced) return;
      card.addEventListener('mouseenter', () => {
        gsap.to(card, { y: -8, duration: 0.5, ease: 'power3.out' });
      });
      card.addEventListener('mouseleave', () => {
        gsap.to(card, { y: 0, duration: 0.6, ease: 'power3.out' });
      });
    });

    // Stats: count-up animado
    document.querySelectorAll('.v-stat__num').forEach((el) => {
      const raw = el.textContent.trim();
      const m = raw.match(/^(\+?)(\d+)(\+?)$/);
      if (!m) return;
      const prefix = m[1];
      const target = parseInt(m[2], 10);
      const suffix = m[3];
      if (target > 9999) return;
      const obj = { val: 0 };
      ScrollTrigger.create({
        trigger: el,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          gsap.to(obj, {
            val: target,
            duration: 1.6,
            ease: 'power2.out',
            onUpdate: () => {
              el.textContent = prefix + Math.round(obj.val) + suffix;
            },
          });
        },
      });
    });

    /* ---------- 11. Refresh tras carga total ---------- */
    window.addEventListener('load', () => ScrollTrigger.refresh());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
